'use strict';
{
    var app = angular.module('tf.portfolio.widgets.strategy.payoff', [])
        .controller('strategyPayoffCtrl', ['$scope', '$uibModal', function strategyPayoffCtrl($scope, $uibModal) {

            // $scope.$on('gridster-resized', function () {
            //     resizePayoff();
            // });
            //
            // $scope.$on('gridster-item-resized-stop', function (widget) {
            //     resizePayoff();
            // });
            //
            // $scope.$watch('gridsterItem.sizeY', function () {
            //     resizePayoff();
            // });

            function resizePayoff() {
                $scope.widgetContentHeight = $scope.gridsterItem.getElementSizeY() - 50 - 32 - 20 - 50;
                $scope.payoffDataOptions.chart.height = $scope.widgetContentHeight;
                if ($scope.chartApi) {
                    $scope.chartApi.refresh();
                }
            }

            $scope.payoffDataOptions = {
                chart: {
                    type: 'lineChart',
                    height: 457,
                    margin
                        : {
                        top: 20,
                        right: 20,
                        bottom: 20,
                        left: 55
                    },
                    x: function (d) {
                        return d.x;
                    },
                    y: function (d) {
                        return d.y;
                    },
                    useInteractiveGuideline: true,
                    interactiveLayer : {
                        tooltip : {
                            // This is broken but looks better than the other options
                            gravity : 'center',
                            headerFormatter : function (d) {
                                var steps = ($scope.priceSteps.length - 1) / 2;

                                var index = d + steps;
                                if ($scope.points) {
                                    return "Price " + d3.format(',.01f')($scope.priceSteps[index]);
                                } else {
                                    return "Price " + d3.format(',.03f')($scope.priceSteps[index]);
                                }
                            }
                        }
                    },
                    dispatch: {},
                    xAxis: {
                        axisLabel: 'Price Change',
                        tickFormat: function(d) {
                            var steps = ($scope.priceSteps.length - 1) / 2;

                            var index = d + steps;
                            if ($scope.points) {
                                return d3.format(',.01f')($scope.priceSteps[index]);
                            } else {
                                return d3.format(',.03f')($scope.priceSteps[index]);
                            }
                        }

                    },

                    yAxis: {
                        axisLabel: 'Payoff ($)',
                        tickFormat: function (d) {
                            return d3.format(',f')(d);
                        },
                        axisLabelDistance: 0
                    }
                }
            };
        }]);
}
